import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./index.less";
import { adaptSize } from '../../utils/remAdapter'
import { useHashAnchor } from '../../hooks/useHashAnchor'

// 导入图片资源
import aboutBg from '../../assets/newVersion/about-bg.avif'
import aboutLogo from '../../assets/newVersion/about/title-logo.png'
import line11 from '../../assets/newVersion/about/line1-1.png'
import line12 from '../../assets/newVersion/about/line1-2.png'
import line21 from '../../assets/newVersion/about/line2-1.png'
import line22 from '../../assets/newVersion/about/line2-2.png'

import aboutBanner2 from '../../assets/newVersion/about-banner2.avif'
import aboutBanner3 from '../../assets/newVersion/about-banner-3.avif'
import mouse from '../../assets/newVersion/mouse.svg'
import journeyTogether from '../../assets/newVersion/journey-together.svg'

// 轮播合作商家图片
import gaode from '../../assets/newVersion/about/gaode.png'
import kedaxunfei from '../../assets/newVersion/about/kedaxunfei.png'
import mayi from '../../assets/newVersion/about/mayi.png'
import meituan from '../../assets/newVersion/about/meituan.png'
import zhongguoshiyou from '../../assets/newVersion/about/zhongguoshiyou.png'
import zhongguoshihua from '../../assets/newVersion/about/zhongguoshihua.png'
import zhongguotieta from '../../assets/newVersion/about/zhongguotieta.png'
import guojiadianwang from '../../assets/newVersion/about/guojiadianwang.png'
import zhongguoyidong from '../../assets/newVersion/about/zhongguoyidong.png'
import neusoft from '../../assets/newVersion/about/neusoft.png'
import haibingkeji from '../../assets/newVersion/about/haibingkeji.png'
import chelingkeji from '../../assets/newVersion/about/chelingkeji.png'
import xiaopeng from '../../assets/newVersion/about/xiaopeng.png'
import baoma from '../../assets/newVersion/about/baoma.png'
import jiliqiche from '../../assets/newVersion/about/jiliqiche.png'
import hongqi from '../../assets/newVersion/about/hongqi.png'
import changanqiche from '../../assets/newVersion/about/changanqiche.png'
import sailisi from '../../assets/newVersion/about/sailisi.png'
import yuchuang from '../../assets/newVersion/about/yuchuang.png'
import beidouzhilian from '../../assets/newVersion/about/beidouzhilian.png'
import lanjingzhineng from '../../assets/newVersion/about/lanjingzhineng.png'
import zhongguojiansheyinhang from '../../assets/newVersion/about/zhongguojiansheyinhang.png'
import nanjingyinhang from '../../assets/newVersion/about/nanjingyinhang.png'
import huaxiayinhang from '../../assets/newVersion/about/huaxiayinhang.png'
import xingyeyinhang from '../../assets/newVersion/about/lanjingzhineng.png'
import shunfeng from '../../assets/newVersion/about/shunfeng.png'
import pepsi from '../../assets/newVersion/about/pepsi.png'
import haier from '../../assets/newVersion/about/haier.png'
import huolala from '../../assets/newVersion/about/huolala.png'
import arlslerg from '../../assets/newVersion/about/arlslerg.png'
import mcdonalds from '../../assets/newVersion/about/mcdonalds.png'
import yiqi from '../../assets/newVersion/about/yiqi.png'
import shangqidatong from '../../assets/newVersion/about/shangqidatong.png'
import kaiyiqiche from '../../assets/newVersion/about/kaiyiqiche.png'
import _212 from '../../assets/newVersion/about/212.png'
import shangqidazhong from '../../assets/newVersion/about/shangqidazhong.png'
import dongfengqiche from '../../assets/newVersion/about/dongfengqiche.png'
import lantu from '../../assets/newVersion/about/lantu.png'
import JMC from '../../assets/newVersion/about/JMC.png'
import fute from '../../assets/newVersion/about/fute.png'

// 导入证书图片
import zs1 from '../../assets/newVersion/about/zs01.png';
import zs2 from '../../assets/newVersion/about/zs02.png';
import zs3 from '../../assets/newVersion/about/zs03.png';
import zs4 from '../../assets/newVersion/about/zs04.png';
import zs5 from '../../assets/newVersion/about/zs05.png';
import zs6 from '../../assets/newVersion/about/zs06.png';
import zs7 from '../../assets/newVersion/about/zs07.png';
import zs8 from '../../assets/newVersion/about/zs08.png';
import zs9 from '../../assets/newVersion/about/zs09.png';

gsap.registerPlugin(ScrollTrigger);

const partnerLogos1 = [
  { url: gaode, x: adaptSize(115), y: adaptSize(32) },
  { url: mayi, x: adaptSize(119), y: adaptSize(48) },
  { url: meituan, x: adaptSize(78), y: adaptSize(32) },
  { url: zhongguoshiyou, x: adaptSize(121), y: adaptSize(32) },
  { url: zhongguoshihua, x: adaptSize(125), y: adaptSize(36) },
  { url: zhongguotieta, x: adaptSize(134.15), y: adaptSize(48) },
  { url: guojiadianwang, x: adaptSize(121), y: adaptSize(38) },
  { url: zhongguoyidong, x: adaptSize(116), y: adaptSize(36) },
  { url: neusoft, x: adaptSize(106), y: adaptSize(20) },
  { url: haibingkeji, x: adaptSize(139), y: adaptSize(42) },
  { url: kedaxunfei, x: adaptSize(156), y: adaptSize(43) },
];

const partnerLogos2 = [
  { url: chelingkeji, x: adaptSize(118), y: adaptSize(36) },
  { url: xiaopeng, x: adaptSize(59), y: adaptSize(30) },
  { url: baoma, x: adaptSize(48), y: adaptSize(48) },
  { url: jiliqiche, x: adaptSize(182.91), y: adaptSize(23) },
  { url: hongqi, x: adaptSize(65), y: adaptSize(40) },
  { url: changanqiche, x: adaptSize(120.28), y: adaptSize(30.17) },
  { url: sailisi, x: adaptSize(104), y: adaptSize(36) },
  { url: yuchuang, x: adaptSize(112), y: adaptSize(32) },
  { url: beidouzhilian, x: adaptSize(196), y: adaptSize(24) },
  { url: lanjingzhineng, x: adaptSize(125), y: adaptSize(40) },
  { url: yiqi, x: adaptSize(170), y: adaptSize(46) },
  { url: shangqidatong, x: adaptSize(170), y: adaptSize(48) },
  { url: _212, x: adaptSize(110), y: adaptSize(58) },
  { url: kaiyiqiche, x: adaptSize(86), y: adaptSize(77) },
  { url: shangqidazhong, x: adaptSize(72), y: adaptSize(67) },
  { url: dongfengqiche, x: adaptSize(112), y: adaptSize(74) },
  { url: lantu, x: adaptSize(44), y: adaptSize(62) },
  { url: JMC, x: adaptSize(64), y: adaptSize(64) },
  { url: fute, x: adaptSize(100), y: adaptSize(36) },
];

const partnerLogos3 = [
  { url: zhongguojiansheyinhang, x: adaptSize(132), y: adaptSize(40) },
  { url: nanjingyinhang, x: adaptSize(125.08), y: adaptSize(33) },
  { url: huaxiayinhang, x: adaptSize(106), y: adaptSize(40) },
  { url: xingyeyinhang, x: adaptSize(160), y: adaptSize(40) },
  { url: shunfeng, x: adaptSize(99.2), y: adaptSize(40) },
  { url: pepsi, x: adaptSize(128), y: adaptSize(40) },
  { url: haier, x: adaptSize(116), y: adaptSize(38) },
  { url: huolala, x: adaptSize(103), y: adaptSize(34) },
  { url: arlslerg, x: adaptSize(100), y: adaptSize(48) },
  { url: mcdonalds, x: adaptSize(78.77), y: adaptSize(56) },
];

const zsList = [
  { url: zs3, title: '高新技术企业证书', content: ['北京市科学技术委员会', '北京市财政局', '国家税务总局北京市税务局'], number: '03', x: 215, y: 150, t: 21 },
  { url: zs6, title: '质量管理体系认证证书', content: ['北京坤标检验认证有限公司'], number: '06', x: 126, y: 180, t: 40 },
  { url: zs9, title: '北京市"专精特新"中小企业', content: ['北京市经济和信息化局'], number: '09', x: 215, y: 150, t: 40 },
  { url: zs3, title: '高新技术企业证书', content: ['北京市科学技术委员会', '北京市财政局', '国家税务总局北京市税务局'], number: '03', x: 215, y: 150, t: 21 },
  { url: zs6, title: '质量管理体系认证证书', content: ['北京坤标检验认证有限公司'], number: '06', x: 126, y: 180, t: 40 },
  { url: zs9, title: '北京市"专精特新"中小企业', content: ['北京市经济和信息化局'], number: '09', x: 215, y: 150, t: 40 },
  { url: zs3, title: '高新技术企业证书', content: ['北京市科学技术委员会', '北京市财政局', '国家税务总局北京市税务局'], number: '03', x: 215, y: 150, t: 21 },
  { url: zs6, title: '质量管理体系认证证书', content: ['北京坤标检验认证有限公司'], number: '06', x: 126, y: 180, t: 40 },
  { url: zs9, title: '北京市"专精特新"中小企业', content: ['北京市经济和信息化局'], number: '09', x: 215, y: 150, t: 40 },
  { url: zs1, title: '甲级测绘资质证书', content: ['北京市规划和自然资源管理委员会'], number: '01', x: 213, y: 150, t: 41 },
  { url: zs4, title: '信息技术服务管理体系认证证书', content: ['兴原认证中心有限公司'], number: '04', x: 126, y: 180, t: 14 },
  { url: zs7, title: 'CMMI证书', content: ['ISACA (CMMI研究院) 认证'], number: '07', x: 215, y: 150, t: 40 },
  { url: zs1, title: '甲级测绘资质证书', content: ['北京市规划和自然资源管理委员会'], number: '01', x: 213, y: 150, t: 41 },
  { url: zs4, title: '信息技术服务管理体系认证证书', content: ['兴原认证中心有限公司'], number: '04', x: 126, y: 180, t: 14 },
  { url: zs7, title: 'CMMI证书', content: ['ISACA (CMMI研究院) 认证'], number: '07', x: 215, y: 150, t: 40 },
  { url: zs1, title: '甲级测绘资质证书', content: ['北京市规划和自然资源管理委员会'], number: '01', x: 213, y: 150, t: 41 },
  { url: zs4, title: '信息技术服务管理体系认证证书', content: ['兴原认证中心有限公司'], number: '04', x: 126, y: 180, t: 14 },
  { url: zs7, title: 'CMMI证书', content: ['ISACA (CMMI研究院) 认证'], number: '07', x: 215, y: 150, t: 40 },
  { url: zs2, title: '乙级测绘资质证书', content: ['北京市规划和自然资源管理委员会'], number: '02', x: 215, y: 150, t: 40 },
  { url: zs5, title: '信息安全管理体系认证证书', content: ['兴原认证中心有限公司'], number: '05', x: 126, y: 180, t: 40 },
  { url: zs8, title: '北京市"创新型"中小企业', content: ['北京市经济和信息化局'], number: '08', x: 215, y: 150, t: 40 },
  { url: zs2, title: '乙级测绘资质证书', content: ['北京市规划和自然资源管理委员会'], number: '02', x: 215, y: 150, t: 40 },
  { url: zs5, title: '信息安全管理体系认证证书', content: ['兴原认证中心有限公司'], number: '05', x: 126, y: 180, t: 40 },
  { url: zs8, title: '北京市"创新型"中小企业', content: ['北京市经济和信息化局'], number: '08', x: 215, y: 150, t: 40 },
  { url: zs2, title: '乙级测绘资质证书', content: ['北京市规划和自然资源管理委员会'], number: '02', x: 215, y: 150, t: 40 },
  { url: zs5, title: '信息安全管理体系认证证书', content: ['兴原认证中心有限公司'], number: '05', x: 126, y: 180, t: 40 },
  { url: zs8, title: '北京市"创新型"中小企业', content: ['北京市经济和信息化局'], number: '08', x: 215, y: 150, t: 40 },
];

const About: React.FC = () => {
  useHashAnchor();
  const containerRef = useRef<HTMLDivElement>(null);
  const stageRef = useRef<HTMLDivElement>(null);
  const line1Ref = useRef<HTMLImageElement>(null);
  const line2Ref = useRef<HTMLImageElement>(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const ctx = gsap.context(() => {
      const introTl = gsap.timeline({ defaults: { ease: "power2.out" } });

      introTl.from(line1Ref.current, {
        width: '2%',
        height: '3%',
        duration: 1.4,
      }, 0.5).from('.line12', {
        opacity: 0,
        duration: .6
      }, 0.5)
      introTl.from(line2Ref.current, {
        width: '2.6%',
        duration: 1.5,
      }, 0.2).from(".stage-first-content", { opacity: 0, duration: 1.5, ease: "power2.out" }, 0.3)
        .from(".morphing-logo", { opacity: 0, duration: 2 }, 0.5)
        .from(".mouse", { opacity: 0, y: adaptSize(20), duration: 1 }, 1);

      const transitionTl = gsap.timeline({
        scrollTrigger: {
          trigger: stageRef.current,
          pin: true,
          scrub: 1.5,
          start: "top top",
          end: "+=500%",
          anticipatePin: 1,
        }
      });

      transitionTl.to(".f-title-w", {
        left: adaptSize('181px'),
        top: `calc(50% - ${adaptSize('205px')}`,
      }, 0);
      transitionTl.to(".f-title", {
        color: '#333',
        // textShadow: '0 0 0 rgba(0, 0, 0, 0)',
        fontSize: adaptSize('28px'),
        lineHeight: adaptSize('39px'),
        ease: "none"
      }, 0);
      transitionTl.fromTo(".f-msg", {
        opacity: 1,
      }, {
        opacity: 0
      }, 0);

      transitionTl.fromTo(".morphing-bg",
        {
          width: "100vw",
          height: "100vh",
          right: 0,
          bottom: 0,
          top: "auto",
          left: "auto"
        },
        {
          width: adaptSize('1037px'),
          height: adaptSize('584px'),
          right: adaptSize('149px'),
          bottom: "50%",
          marginBottom: adaptSize('-292px'),
          ease: "none"
        },
        0
      );
      transitionTl.to(".mouse", {
        opacity: 0
      }, 0);

      transitionTl.from(".stage-box1-left",
        { opacity: 0 },
        '>-0.2'
      ).to(".f-title-w",
        { opacity: 0, duration: 0 }
      ).to(".stage-box1-left .title",
        { opacity: 1, duration: 0 }, "<"
      ).to(".stage-box-left-w",
        {
          top: `calc(50% + ${adaptSize('308px')})`, ease: "none"
        }, '>-0.5'
      ).addLabel('box1').to(".stage-box-left-w",
        {
          y: adaptSize('-16px')
        },
      ).to(".stage-box1-left",
        {
          marginTop: adaptSize('-16px')
        }, "<"
      ).to(".stage-box1-left",
        { marginTop: adaptSize('-600px') }
      ).to(".stage-box-left-w",
        {
          y: adaptSize('-600px')
        }, "<"
      ).to(".stage-box-right-i",
        { top: 0 }, "<"
      ).to(".morphing-bg",
        {
          y: adaptSize('-584px'),
        }, "<"
      ).to(".morphing-wrap",
        { height: adaptSize('584px') }, "<"
      ).addLabel('box2').to(".stage-box-left-w",
        {
          y: adaptSize('-616px'), duration: 0.5
        }
      ).to(".stage-box1-left",
        { marginTop: adaptSize('-616px'), duration: 0.5 }, "<"
      ).to(".stage-box1-left",
        { marginTop: adaptSize('-1200px') }
      ).to(".stage-box-left-w",
        {
          y: adaptSize('-1200px')
        }, "<"
      ).to(".stage-box-right-i",
        { top: adaptSize('-584px') }, "<"
      ).to(".stage-box-right-i",
        { top: adaptSize('-584px') }, 'box3'
      );

      // scroll-fifth 入场动画
      gsap.from(".scroll-fifth .f-title-box", {
        opacity: 0,
        y: adaptSize(40),
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".scroll-fifth",
          start: "top 75%",
        }
      });

      gsap.from(".scroll-fifth .f-msg-box", {
        opacity: 0,
        y: adaptSize(30),
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".scroll-fifth",
          start: "top 75%",
        }
      });

      gsap.from(".scroll-fifth .info-box .info-item", {
        opacity: 0,
        y: adaptSize(60),
        duration: 0.9,
        stagger: 0.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".scroll-fifth .info-box",
          start: "top 80%",
        }
      });

      gsap.from(".scroll-fifth .report-box", {
        opacity: 0,
        y: adaptSize(50),
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".scroll-fifth .report-box",
          start: "top 85%",
        }
      });

    }, containerRef);

    const handleResize = () => {
      ScrollTrigger.refresh();
    };
    window.addEventListener('resize', handleResize);

    return () => {
      ctx.revert();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="aboutus-corp-page" ref={containerRef}>
      <div className="stage-section" ref={stageRef}>
        <div className="stage-wrapper">
          <div className="stage-first-content">
            <div className="f-title-w">
              <div className="f-title">征程与共<span className="doit">·</span>一路同行</div>
              <img src={journeyTogether} className="f-msg" />
            </div>
            <img src={mouse} alt="scroll" className="mouse" />
          </div>

          <div className="morphing-bg">
            <img className="morphing-logo" src={aboutLogo} alt="dafang" />
            <img src={aboutBg} alt="background" />
            <div className="line1-w" ref={line1Ref} >
              <img src={line11} className="line11" />
              <img src={line12} className="line12" />
            </div>
            <div className="line2-w" ref={line2Ref} >
              <img src={line21} className="line21" />
              <img src={line22} className="line22" />
            </div>
            <div className="morphing-wrap">
            </div>
          </div>

          <div className="stage-box1-left" id="qiyejieshao">
            <div className="square"></div>
            <div className="title">
              征程与共<span className="doit"></span>一路同行
            </div>
            <div className="msg">
              北京大方云图科技有限公司（甲级测绘资质企业）成立于2021年，是阿里巴巴高德事业群的生态公司，专注出行及地理信息行业。
            </div>
          </div>
          <div className="stage-box-left-w">
            <div className="stage-box stage-box-2">
              <div className="stage-box2-left left">
                <div className="square"></div>
                <div className="title">关于 DAFANG</div>
                <div className="msg">
                  公司坚持以人为本的原则，云集业界精英。公司创始人团队出自阿里，具备成熟完善的信息技术、管理方法及企业经验，注重人才成长。公司核心团队拥有多名名校毕业的博士、硕士，团队骨干多来自阿里巴巴、百度、360等知名互联网公司，公司总部位于北京市朝阳区望京科技园，辐射上海、广州、厦门、石家庄、合肥、武汉、南京等地研发中心，员工超360人。
                </div>
              </div>
            </div>
            <div className="stage-box stage-box-3">
              <div className="stage-box3-left left ">
                <div className="square"></div>
                <div className="title">技术优势</div>
                <div className="msg">
                  公司以"定位、导航、路线、地图制作"四个核心技术为支柱，为智能汽车及大出行产业提供全链路技术解决方案。与众多国内外汽车企业、头部地图服务商、能源企业、信息产业、消费品公司、互联网企业，保持着良好的合作关系。与车企一同进入到智能驾驶新浪潮中，支持更多企业经营管理数字化转型。
                </div>
              </div>
            </div>
          </div>

          <div className="stage-box-right-w">
            <div className="stage-box-right-i">
              <img src={aboutBanner2} alt="about dafang" className="stage-box2-right right" />
              <img src={aboutBanner3} alt="technical advantage" className="stage-box3-right right" />
            </div>
          </div>
          <div className='stage-masker-t'></div>
          <div className='stage-masker-b'></div>
        </div>
      </div>

      <div className="scroll-third" id="hezuohuoban">
        <div className="t-title-box">
          <div className="title">合作伙伴</div>
          <div className="msg">银行、互联网、汽车等领域拥有众多合作伙伴</div>
        </div>
        <div className="t-carousel">
          <div className="t-carousel-row">
            <div className="t-carousel-track">
              {[...partnerLogos1, ...partnerLogos1].map((item, idx) => (
                <div className="t-c-item" key={`row1-${idx}`}>
                  <img src={item.url} style={{ width: item.x, height: item.y }} alt="" draggable={false} />
                </div>
              ))}
            </div>
          </div>
          <div className="t-carousel-row">
            <div className="t-carousel-track">
              {[...partnerLogos2, ...partnerLogos2].map((item, idx) => (
                <div className="t-c-item" key={`row2-${idx}`}>
                  <img src={item.url} style={{ width: item.x, height: item.y }} alt="" draggable={false} />
                </div>
              ))}
            </div>
          </div>
          <div className="t-carousel-row">
            <div className="t-carousel-track">
              {[...partnerLogos3, ...partnerLogos3].map((item, idx) => (
                <div className="t-c-item" key={`row3-${idx}`}>
                  <img src={item.url} style={{ width: item.x, height: item.y }} alt="" draggable={false} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-fourth" id="rongyuyuzizhi">
        <div className="left">
          <div className="title">荣誉与资质</div>
          <div className="msg">截止2024年底，共获得荣誉与资质</div>
          <div className="num-box">
            <div className="num">9</div>
            <div className="unit">项</div>
          </div>
        </div>
        <div className="right">
          {[0, 1, 2].map((col) => (
            <div className="column" key={'col' + col}>
              {zsList.slice(col * 9, col * 9 + 9).map((item, idx) => (
                <div className="item" key={idx}>
                  <div className="ri-head">
                    <div className="ri-left">{item.number}</div>
                    <div className="ri-right">
                      <div className="ri-title">{item.title}</div>
                      {item.content.map((i, j) => (
                        <div className="ri-msg" key={idx + '-' + j}>{i}</div>
                      ))}
                    </div>
                  </div>
                  <img
                    src={item.url}
                    className="ri-bottom"
                    style={{ width: adaptSize(item.x + 'px'), height: adaptSize(item.y + 'px'), marginTop: adaptSize(item.t + 'px') }}
                    alt=""
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>


      <div className="scroll-fifth" id="heguiyuchengxin">
        <div className="f-title-box">
          <div className="f-square"></div>
          <div className="ft-title">合规与诚信</div>
        </div>
        <div className="f-msg-box">
          诚信经营、遵纪守法是大方云图的核心经营理念。公司持续搭建标准化合规管理体系，将合规管控嵌入全业务流程，致力于打造诚实、透明、负责任的企业文化。
        </div>

        <div className="info-box">
          <div className="info-item">
            <div className="fi-title">我们的承诺</div>
            <div className="fi-msg">严格遵守国家及地方现行全部适用法律法规；恪守商业道德，坚决抵制腐败、商业贿赂、欺诈及各类不正当竞争行为；依法保障客户、合作伙伴、全体员工的各项合法权益；常态化开展全员合规培训，依托培训、问责机制落地长效合规文化。</div>
          </div>
          <div className="info-item">
            <div className="fi-title">合规管理</div>
            <div className="fi-msg">大方云图搭建覆盖核心业务全流程的合规管控机制：常态化识别、评估各业务环节合规风险，配套落地对应风险管控措施；向所有合作方明确合规合作标准，对存在不合规行为的合作方终止合作；定期组织合规培训、内部合规自查，持续迭代优化合规管理体系。</div>
          </div>
        </div>

        <div className="report-box">
          <div className="left">
            <div className="r-title">
              <div className="r-square"></div>
              <span className="text">举报渠道</span>
            </div>
            <div className="r-msg">若您发现大方云图员工、合作方存在违法违规、腐败贿赂、商业欺诈及其他违背诚信经营的行为，可通过以下渠道提交举报。</div>
            <div className="r-email">
              <div className="r-email-title">举报邮箱：</div>
              <div className="r-email-msg">Dfpublic@dafangyuntu.com</div>
            </div>
          </div>
          <div className="right"></div>
        </div>
      </div>
    </div>
  );
};

export default About;